import { useMutation } from '@tanstack/react-query';
import { editComment } from './editComment';
import { globalErrorResponse } from '../../../shared/notification/actions';
import { AxiosError } from 'axios';
import { invalidateComments } from './useComments';

export const useEditComment = () => {
    return useMutation(editComment, {
        onSuccess: (_, ctx) => {
            invalidateComments(ctx.listId).then();
        },
        onError: (error: AxiosError) => globalErrorResponse(error)
    });
};
